/*
    路由规则
*/
// 内嵌页主组件（嵌套路由的最高层）
import Index from '@/components/common/Index'

// portal部分
import PortalIndex from '@/views/portal/Index'

// 用户中心部分
export default [
    {
        path: '/',
        name: 'Index',
        component: Index, // 此组件为模板页
        children:[ // 子路由，成功匹配，则填充到<router-view>
            {
                // 门户主页
                path: '/',
                name: 'PortalIndex',
                component: PortalIndex
            },
            {
                path: '/MapSearch',
                name: 'MapSearch',
                component: ()=> import('@/views/portal/MapSearch')
            },
            {
                path: '/News',
                name: 'News',
                component: ()=> import('@/views/portal/News')
            },
            {
                path: '/Service',
                name: 'Service',
                component: ()=> import('@/views/portal/Service')
            },    
            {
                path: '/Download',
                name: 'Download',
                component: ()=> import('@/views/portal/Download')
            },          
            {
                path: '/Policy',
                name: 'Policy',
                component: ()=> import('@/views/portal/Policy')
            },
            {
                // 关于我们
                path: '/ContactUs',
                name: 'ContactUs',
                component: ()=> import('@/views/portal/ContactUs')
            },
            {
                path: '/NewsDetail',
                name: 'NewsDetail',
                component: ()=> import('@/views/portal/NewsDetail')
            }, 
            {
                path: '/PubilcyInfo',
                name: 'PubilcyInfo',
                component: ()=> import('@/views/portal/PubilcyInfo')
            },   
            {
                path: '/PubilcyWaitingInfo',
                name: 'PubilcyWaitingInfo',
                component: ()=> import('@/views/portal/PubilcyWaitingInfo')
            },    
            {
                path: '/PubilcyWaitingNum',
                name: 'PubilcyWaitingNum',
                component: ()=> import('@/views/portal/PubilcyWaitingNum')
            },          
            {
                // 小区展示
                path: "/HouseList",
                name: "HouseList",
                component: () => import('@/views/portal/HouseList')
            },
            {
                // 小区详情展示
                path: "/HouseDetail",
                name: "HouseDetail",
                component: () => import('@/views/portal/HouseDetail')
            },
            {
                // 小区户型详情展示
                path: "/HouseTypeDetail",
                name: "HouseTypeDetail",
                component: () => import('@/views/portal/HouseTypeDetail')
            },
            {
                // 咨询服务
                path: "/InfomationCenter",
                name: "InfomationCenter",
                component: () => import('@/views/portal/InfomationCenter')
            },
            {
                 path: "/ForgetPassword",
                 name: "ForgetPassword",
                 component: () => import('@/components/login/ForgetPassword')
            },
            {
                path: "/QueryWaitingNum",
                name: "QueryWaitingNum",
                component: () => import('@/views/portal/QueryWaitingNum')
            },
            {
                // 下面开始是用户中心部分（也是嵌套）
                path: "/User",
                name: "UserIndex",
                component: () => import('@/views/user/Index'),
                children: [
                    {
                        // 我的订单
                        path: "/",
                        name: "User_MyOrder",
                        component: ()=> import('@/views/user/MyOrder')
                    },
                    {
                        // 我的预约
                        path: "/User/MyAppointment",
                        name: "User_MyAppointment",
                        component: () => import('@/views/user/MyAppointment')
                    },
                    {
                        // 我的合同
                        path: "/User/MyContract",
                        name: "User_MyContract",
                        component: ()=> import('@/views/user/MyContract')
                    },{
                        // 合同详情
                        path: "/User/ContractDetail",
                        name: "User_ContractDetail",
                        component: ()=> import('@/views/user/ContractDetail')
                    },
                    {
                        // 修改账号信息
                        path: "/User/ModifyUserInfo",
                        name: "User_ModifyUserInfo",
                        component: () => import('@/views/user/ModifyUserInfo')
                    },
                    {
                        // 在线缴费
                        path: "/User/MyPaymentList",
                        name: "User_MyPaymentList",
                        component: () => import('@/views/user/MyPaymentList')
                    },
                    {
                        // 提前退租
                        path: "/User/RentCancellation",
                        name: "User_RentCancellation",
                        component: () => import('@/views/user/RentCancellation')
                    },
                    {
                        // 续租征询
                        path: "/User/RerentConsultion",
                        name: "User_RerentConsultion",
                        component: () => import('@/views/user/RerentConsultion')
                    },
                    {
                        // 在线报修
                        path: "/User/MyRepairList",
                        name: "User_MyRepairList",
                        component: () => import('@/views/user/MyRepairList')
                    },
                    {
                        // 报修详情
                        path: "/User/RepairDetail",
                        name: "User_RepairDetail",
                        component: () => import('@/views/user/RepairDetail')
                    },
                    {
                        // 电子发票
                        path: "/User/MyInvoice",
                        name: "User_MyInvoice",
                        component: () => import('@/views/user/MyInvoice')
                    },
                    {
                        // 账号管理
                        path: "/User/Account",
                        name: "User_Account",
                        component: () => import('@/views/user/Account')
                    },
                    {
                        // 排号查询
                        path: "/User/QuerySequence",
                        name: "QuerySequence",
                        component: () => import('@/views/user/QuerySequence')
                    },
                    {
                        // 在线选房
                        path: "/User/SelectRoom",
                        name: "User_SelectRoom",
                        component: () => import('@/views/user/SelectRoom')
                    }

                    /* {
                        // 申请资格
                        path: "/User/RenterApply",
                        name: "User_RenterApply",
                        component: ()=> import('@/views/user/RenterApply')
                    }, */
                ]
            },
            {
                // 租房申请
                path: "/Apply",
                name: "Apply",
                component: () => import('@/views/user/Apply'),
                children: [
                    {
                        // 申请第一步
                        path: "/",
                        name: "User_ApplyFir",
                        component: ()=> import('@/views/user/ApplyFir')
                    },
                    {
                        // 申请第二步
                        path: "/Apply/ApplySec",
                        name: "User_ApplySec",
                        component: ()=> import('@/views/user/ApplySec')
                    },
                    {
                        // 申请第三步
                        path: "/Apply/ApplyThir",
                        name: "User_ApplyThir",
                        component: ()=> import('@/views/user/ApplyThir')
                    },
                    {
                        // 申请成功
                        path: "/Apply/ApplyForth",
                        name: "User_ApplyForth",
                        component: ()=> import('@/views/user/ApplyForth')
                    },
                    {
                        // 人员变更管理
                        path: "/Apply/ApplyPersonChange",
                        name: "User_ApplyPersonChange",
                        component: ()=> import('@/views/user/ApplyPersonChange')
                    },
                     {
                         // 资料补充
                         path: "/Apply/ApplyInfoSupply",
                         name: "User_ApplyInfoSupply",
                         component: ()=> import('@/views/user/ApplyInfoSupply')
                     }
                ]
            },
        ]
    },
    /*这些是测试用的 */
    /* {
        path: '/Sample/Login',
        name: 'Login',
        component: () => import('@/views/sample/Login')
    },
    {
        path: '/Sample/Index',
        name: 'SampleIndex',
        component: () => import('@/views/sample/Index')
    },
    {
        path: '/Sample/Upload',
        name: 'SampleUpload',
        component: () => import('@/views/sample/Upload')
    }, */
    {
        // 匹配不到，跳转404页
        path: '*',
        name: 'Page404',
        component: () => import('@/components/error/404'),
    }
]